export default __webpack_public_path__ + "static/media/Logo.cea541ab.png";